import {
  QuestionIcon,
  ChatIcon as ChatRoundedIcon,
  CloudIcon as CloudRoundedIcon,
  SmileyIcon as EmojiEmotionsRoundedIcon,
  HeartIcon as FavoriteIcon,
  LinkIcon as LinkRoundedIcon,
  MapPinIcon as PinDropRoundedIcon,
  StarHalfIcon as StarHalfRoundedIcon,
  HandWavingIcon as WavingHandIcon
} from '@phosphor-icons/react';

const FEATURES = [{
  index: 0,
  name: 'Welcome',
  slug: 'slide-first',
  icon: <WavingHandIcon size={20} className="text-grey-700" />,
}, {
  index: 1,
  name: 'Magic Map',
  icon: <PinDropRoundedIcon size={20} className="text-grey-700" />,
  slug: 'map-1',
}, {
  index: 2,
  name: 'Wonder Words',
  icon: (
    <CloudRoundedIcon size={20}
      className="text-grey-700"
    />
  ),
  slug: 'wordcloud-1',
}, {
  index: 3,
  name: 'Power Poll',
  slug: 'poll-1',
  icon: (
    <img className="w-5 h-5" src="images/ros/interactions/bar_chart.svg" />
  ),
}, {
  index: 4,
  name: 'Transient Thoughts',
  slug: 'thought-1',
  icon: (
    <ChatRoundedIcon size={20} className="text-grey-700" />
  ),
}, {
  index: 5,
  name: 'Talking Tiles',
  slug: 'tiles-1',
  icon: (
    <img className="w-5 h-5" src="/images/ros/interactions/talking_tiles.svg" />
  ),
}, {
  index: 6,
  name: 'Winning Wheel',
  slug: 'wheel-1',
  icon: (
    <img className="w-5 h-5" src="/images/ros/interactions/wheel.svg" />
  ),
}, {
  index: 7,
  name: 'Emojis Everywhere',
  slug: 'emoji-1',
  icon: (
    <EmojiEmotionsRoundedIcon size={20}
      className="text-grey-700"
    />
  ),
}, {
  index: 8,
  name: 'Power Polls w/o Options',
  slug: 'freeForm-1',
  icon: (
    <img className="w-5 h-5" src="/images/ros/interactions/open_ended_polls.svg" />
  ),
}, {
  index: 9,
  name: 'Rating Polls',
  slug: 'rating-polls-1',
  icon: (
    <StarHalfRoundedIcon size={20}
      className="text-grey-700"
    />
  ),
},
// {
//   index: 10,
//   name: 'Choice Circle',
//   slug: 'choice-circle-1',
//   icon: (
//     <img className="w-5 h-5" src="/images/ros/interactions/wheel.svg" />
//   ),
// },
{
  index: 11,
  name: 'Quick Questions',
  slug: 'quick-question-1',
  icon: (
    <QuestionIcon size={20} className="text-grey-700 dark:text-grey-400" />
  ),
}, {
  index: 13,
  name: 'Link Library',
  slug: 'link-library-1',
  icon: (
    <LinkRoundedIcon size={20} className="text-grey-700" />
  ),
}, {
  index: 14,
  name: 'Thank You',
  slug: 'slide-last',
  icon: <FavoriteIcon size={20} className="text-grey-700" />,
}];

const slugs = FEATURES.map((f) => f.slug);

export const getFeatureBySlug = (slug) => {
  let index = slugs.indexOf(slug);

  if (index === -1) index = 0;

  return FEATURES[index];
};

export const getByIndex = (index) => {
  if (index < 0) return FEATURES[0];

  if (index >= FEATURES.length) return FEATURES[FEATURES.length - 1];

  return FEATURES[index];
};

export default FEATURES;
